import { render } from "./SetPricingGroup.vue?vue&type=template&id=31ce82f2&scoped=true&lang=pug"
import script from "./SetPricingGroup.vue?vue&type=script&lang=js"
export * from "./SetPricingGroup.vue?vue&type=script&lang=js"

import "./SetPricingGroup.vue?vue&type=style&index=0&id=31ce82f2&scoped=true&lang=scss"

import exportComponent from "/builds/wiwdata/applications/finance-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31ce82f2"]])

export default __exports__